import { Controller } from "@hotwired/stimulus";
import intelTelInput from "intl-tel-input";
import { parseNestedKey, objectToNestedKey } from "../helpers/index";

const fieldName = (arrayParts) => {
  return arrayParts.reduce((acc, part) => {
    if (acc === "") {
      return part;
    }

    return `${acc}[${part}]`;
  }, "");
};

// Connects to data-controller="intl-tel"
export default class extends Controller {
  static targets = ["input"];

  nodes(obj, func) {
    let items = [];
    for (const key in obj) {
      items.push(key);
      if (obj[key] !== null && typeof obj[key] === "object") {
        items.push(...func(obj[key], func));
      }
    }

    return items;
  }

  connect() {
    this.intlTelInput = intelTelInput(this.inputTarget, {
      initialCountry: "auto",
      geoIpLookup: function (success, failure) {
        fetch("https://ipinfo.io", {
          headers: {
            Accept: "application/json",
          },
        })
          .then((resp) => {
            if (resp.ok) {
              return resp.json();
            }
            throw new Error("Failed to fetch");
          })
          .then((data) => {
            success(data.country);
          })
          .catch(failure);
      },
      loadUtils: () => import("intl-tel-input/utils"),
      hiddenInput: (telInputName) => {
        const parts = this.nodes(parseNestedKey(telInputName), this.nodes);
        const last = parts.pop();
        parts.push(`${last}_country`);

        return {
          phone: telInputName,
          country: fieldName(parts),
        };
      },
    });
  }
}
